let _ = t => t,
  _t;
import styled from 'styled-components';
import Box from '../Box';
export const Container = styled(Box)(_t || (_t = _`
    display: flex;
    flex-direction: column;

    width: 100%;
    min-width: 160px;
    max-width: 512px;
`));